import { IIconProps, DEFAULT_ICON_PROPS } from './constants';

export const CameraIcon = ({ ariaLabel = 'Profile Picture', ...props }: IIconProps) => {
  const { size, width, height, title, ariaHidden, className } = {
    ...DEFAULT_ICON_PROPS,
    ...props,
  };

  return (
    <svg
      width={size ?? width}
      height={size ?? height}
      viewBox="0 0 40 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby={ariaLabel}
      aria-hidden={ariaHidden}
      className={`block ${className}`}
      {...props}
    >
      {title && <title>{title}</title>}
      <path
        d="M29.5455 4.50854L26.7366 1.026C26.2133 0.377181 25.4245 0 24.591 0H15.409C14.5755 0 13.7867 0.377182 13.2634 1.026L10.4545 4.50854H6.89144C3.0854 4.50854 0 7.59395 0 11.4V27.1086C0 30.9146 3.08541 34 6.89145 34H33.1086C36.9146 34 40 30.9146 40 27.1086V11.4C40 7.59395 36.9146 4.50854 33.1086 4.50854H29.5455ZM30.5773 18.2354C30.5773 24.2799 25.8424 29.1789 20.0003 29.1789C14.1582 29.1789 9.42325 24.2799 9.42325 18.2354C9.42325 12.1909 14.1582 7.29188 20.0003 7.29188C25.8424 7.29188 30.5773 12.1909 30.5773 18.2354ZM28.8248 18.2352C28.8248 23.2785 24.8725 27.3655 20.0003 27.3655C15.128 27.3655 11.1757 23.2785 11.1757 18.2352C11.1757 13.1919 15.128 9.10492 20.0003 9.10492C24.8725 9.10492 28.8248 13.1919 28.8248 18.2352Z"
        fill="white"
      />
    </svg>
  );
};
